export const GET_STATUS_LOG = "GET_STATUS_LOG";
export const CLEAR_STATUS_LOG = "CLEAR_STATUS_LOG";